import config from 'config';
import { deleteCookie, getCookie, responseError } from 'helpers';
import { APIResponse } from 'types/Request';
import {
  FormaPagoRequest,
} from 'types/FormaPago';

function revokeCredentials() {
  deleteCookie('accessToken');
  deleteCookie('sessionCookie');
  // eslint-disable-next-line no-restricted-globals
  return location.reload();
}

export async function getAllSolicitudesFormaPago(
  matricula: string | null = null,
): Promise<FormaPagoRequest[] | []> {
  try {
    const url = new URL(`${ config.baseUrl }/forma-pago/solicitudes`);

    type Response = APIResponse<FormaPagoRequest[]>

    if (matricula) {
      const params = new URLSearchParams({
        matricula: matricula.toString(),
      });
      url.search = params.toString();
    }

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      return [];
    }

    const content = await response.json() as Response;

    if (content.status !== 'ok') {
      if (content.code === 'CONNECTION_ERROR') {
        return [];
      }

      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las prestaciones. ' +
        'Temporalmente no se podrá enviar la solicitud pero si guardar como Borrador. (1)');
    }

    return content.payload ?? [];
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las prestaciones. ' +
      'Temporalmente no se podrá enviar la solicitud pero si guardar como Borrador. (2)');
  }
}

export async function getFormaPagoRequest(
  formaPagoId: number,
): Promise<FormaPagoRequest | undefined> {
  try {
    const url = new URL(`${ config.baseUrl }/matriculates/forma-pago-request/${ formaPagoId }`);

    type Response = APIResponse<FormaPagoRequest>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      return;
    }

    const content = await response.json() as Response;

    if (content.status !== 'ok') {
      if (content.code === 'CONNECTION_ERROR') {
        return;
      }

      throw new Error(
        'Ocurrió un problema inesperado al momento de intentar recuperar la solicitud de facturación ooss.',
      );
    }

    return content.payload;
  } catch (err) {
    throw new Error(
      'Ocurrió un problema inesperado al momento de intentar recuperar la solicitud de facturación ooss.',
    );
  }
}

export async function postFormaPago(
  data: Partial<FormaPagoRequest>,
): Promise<any | undefined> {
  try {
    const formData = new FormData();

    formData.append('metadata', JSON.stringify(data));

    const res = await fetch(`${ config.baseUrl }/forma-pago`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Authorization: getCookie('accessToken'),
      },
      body: formData,
    });

    if (res.status === 400) return responseError();

    if (res.status === 401 && true) {
      return revokeCredentials();
    }

    return res.json();
  } catch (err) {
    console.error('ApiService', 'Error de conexión al hacer POST de facturación ooss');
    console.info(data);
    console.info(err);
    throw err;
  }
}

export async function putFormaPago(
  data: Partial<FormaPagoRequest>,
): Promise<any | undefined> {
  try {
    const formData = new FormData();

    formData.append('metadata', JSON.stringify(data));

    const res = await fetch(`${ config.baseUrl }/forma-pago/${data.id}`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        Authorization: getCookie('accessToken'),
      },
      body: formData,
    });

    if (res.status === 400) return responseError();

    if (res.status === 401 && true) {
      return revokeCredentials();
    }

    return res.json();
  } catch (err) {
    console.error('ApiService', 'Error de conexión al hacer PUT de facturación ooss');
    console.info(data);
    console.info(err);
    throw err;
  }
}
